import mobile from 'is-mobile'

// TODO remove this when productHeaderInterceptor allows passing in a the overrides

type Props = {
  /** defaults to 'tree:person' */
  featureOverride?: string
  /** defaults to '000' and last part of productHeader */
  versionOverride?: string
}
/**
 * Basically copies productHeaderInterceptor's logic to create a productHeader specific for tree-person-r9;
 */
export default function getProductHeader({ featureOverride, versionOverride }: Props): string {
  const internal = 'int'
  const isMobile = mobile()
  const platform = isMobile ? 'mweb' : 'web'
  const feature = 'tree:person'
  const productHeader = `${internal}-${platform}-${featureOverride ?? feature}-${versionOverride ?? '000'}`

  return productHeader
}
